import { makeRequest } from "@/utils/makeRequest";
import type { AppDispatch } from "..";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { setCurrencies } from "../slices/currencySlice";

export const fetchCurrencies = () => async (dispatch: AppDispatch) => {
  try {
    const res = await makeRequest.get("/currency");
    dispatch(setCurrencies(res.data));
  } catch (error) {
    console.log(error);
    getErrorMessage(error);
  }
};
